import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Survey from './pages/Survey';
import Login from './pages/Login';
import Admin from './pages/Admin';
import KeyInsights from './pages/KeyInsights';
import CartographieInteractive from './pages/CartographieInteractive';
import UserManagement from './pages/UserManagement';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/insights" element={<ProtectedRoute><KeyInsights /></ProtectedRoute>} />
            <Route path="/map" element={<ProtectedRoute><CartographieInteractive /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;